import { PolicyValue, PremiumPayment } from "./PolicyQueueTypes";

import { DropdownItemProps } from "semantic-ui-react";
import { Subscription } from "@itm21st/switchboard";
import { Zoom } from "react-toastify";

export const toastProps = { autoClose: 1000, transition: Zoom };

export const PolicyQueueChannel = "policy-queue";
export const PolicyResourceTitle = "policy";
export enum PolicyAction {
    SubmitPayment = "submit-payment",
    SubmitValue = "submit-value"
}

export const subscription: Subscription = {
    channel: PolicyQueueChannel,
    resource: PolicyResourceTitle
};

export const defaultPolicyValue: PolicyValue = {
    AsOfDate: null,
    CostOfInsurance: null,
    COICharges: false,
    COIDate: null,
    creditingRate: null,
    CSR: null,
    CurAccountValue: null,
    CurSurrenderValue: null,
    GraceAmount: null,
    LapseDate: null,
    LoanBalance: null,
    LoanPayment: null,
    NLG: false,
    PaidUntilDate: null,
    PremiumsPaid: null,
    Standing: null,
    SurrenderCharge: null,
    StatusComment: null
};

export const defaultPremiumPayment: PremiumPayment = {
    CSR: "",
    expected_amount: 0,
    expected_date: new Date(),
    funding_date: new Date(),
    loan_payment_amount: 0,
    premiumpayment_id: 0,
    verification_date: null,
    verified_by: ""
};

export const PolicyStandingOptions: DropdownItemProps[] = [
    {
        text: "Good",
        value: 1,
        key: 1
    },
    {
        text: "Grace",
        value: 2,
        key: 2
    },
    {
        text: "Lapse",
        value: 3,
        key: 3
    }
];
